import { render } from "./Inscription.vue?vue&type=template&id=9ff5b36c&scoped=true"
const script = {}

import "./Inscription.vue?vue&type=style&index=0&id=9ff5b36c&scoped=true&lang=css"
import "./Inscription.vue?vue&type=style&index=1&id=9ff5b36c&scoped=true&lang=css"
import "./Inscription.vue?vue&type=style&index=2&id=9ff5b36c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.22_vue@3.5.22_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ff5b36c"]])

export default __exports__